import * as L from 'leaflet';
import { getJSON } from './util.ts';
import {
  IGeocoder,
  GeocoderOptions,
  GeocodingCallback,  
  geocodingParams,
  GeocodingResult,
  reverseParams
} from './api.ts';

/**
 * Implementation of the [Google Geocoding API](https://developers.google.com/maps/documentation/geocoding/)
 */
export interface GoogleOptions extends GeocoderOptions {}

export class Google implements IGeocoder {
  options: GoogleOptions = {
    serviceUrl: 'https://maps.googleapis.com/maps/api/geocode/json',
    apiKey:"AIzaSyC7Gb6_id5CdWz1kunQNAEIOz1j1VhJj74",
    
  };

  constructor(options?: Partial<GoogleOptions>) {
    L.Util.setOptions(this, options);
  }

  // geocode(query: string, cb: GeocodingCallback, context?: any): void {

  //   const params = geocodingParams(this.options, {
  //     address:query,
  //     key: this.options.apiKey,
  //   });
  //   getJSON(this.options.serviceUrl, params, data => {
  //     const results: GeocodingResult[] = [];
  //     if (data.results && data.results.length) {
  //       for (let i = 0; i <= data.results.length - 1; i++) {
  //         const loc = data.results[i];
  //         const latLng = L.latLng(loc.geometry.location);
  //         const latLngBounds = L.latLngBounds(
  //           L.latLng(loc.geometry.viewport.northeast),
  //           L.latLng(loc.geometry.viewport.southwest)
  //         );
  //         results[i] = {
  //           name: loc.formatted_address,
  //           bbox: latLngBounds,
  //           center: latLng,
  //           properties: loc.address_components
  //         };
  //       }
  //     }

  //     cb.call(context, results);
  //   });
  // }



// Enhanced geocode method to handle coordinate inputs directly and place names via Google API
    geocode(query: string, cb: GeocodingCallback, context?: any): void {
    // Check if the query looks like coordinates
    const coordRegex = /^\s*(-?\d{1,2}\.\d+)\s*[, ]\s*(-?\d{1,3}\.\d+)\s*$/;
    const match = query.match(coordRegex);
  
    if (match) {
      const lat = parseFloat(match[1]);
      const lng = parseFloat(match[2]);
  
      // Create a result directly without calling Google API
      const latLng = L.latLng(lat, lng);
      const result: GeocodingResult = {
        name: `${lat.toFixed(5)}, ${lng.toFixed(5)}`,
        center: latLng,
        bbox: L.latLngBounds(latLng, latLng),
        properties: { source: "manual_coordinates" }
      };
  
      cb.call(context, [result]);
      return;
    }
  
    // Normal place name geocoding using Google API
    const params = geocodingParams(this.options, {
      address: query,
      key: this.options.apiKey,
    });
  
    getJSON(this.options.serviceUrl, params, (data) => {
      const results: GeocodingResult[] = [];
      if (data.results && data.results.length) {
        for (let i = 0; i < data.results.length; i++) {
          const loc = data.results[i];
          const latLng = L.latLng(loc.geometry.location);
          const latLngBounds = L.latLngBounds(
            L.latLng(loc.geometry.viewport.northeast),
            L.latLng(loc.geometry.viewport.southwest)
          );
          results[i] = {
            name: loc.formatted_address,
            bbox: latLngBounds,
            center: latLng,
            properties: loc.address_components,
          };
        }
      }
      cb.call(context, results);
    });
  }

  suggest(query: string, cb: GeocodingCallback,autocomplete:any ,context?: any): void {
    const results: GeocodingResult[] = [];
    autocomplete.getPlacePredictions({input:query},(pred,stat)=>{
      if(stat==="OK"){
        pred.forEach((ele) => {
          results.push({name:ele.description,id:ele.reference})
        });
        cb.call(context,results)
      }else if(stat === "ZERO_RESULTS"){
        cb.call(context,[])
      }
    })
    
  }
  reverse(location: L.LatLngLiteral, scale: number, cb: GeocodingCallback, context?: any): void {
    const params = reverseParams(this.options, {
      key: this.options.apiKey,
      latlng: location.lat + ',' + location.lng
    });
    getJSON(this.options.serviceUrl, params, data => {
      const results: GeocodingResult[] = [];
      if (data.results && data.results.length) {
        for (let i = 0; i <= data.results.length - 1; i++) {
          const loc = data.results[i];
          const center = L.latLng(loc.geometry.location);
          const bbox = L.latLngBounds(
            L.latLng(loc.geometry.viewport.northeast),
            L.latLng(loc.geometry.viewport.southwest)
          );
          results[i] = {
            name: loc.formatted_address,
            bbox: bbox,
            center: center,
            properties: loc.address_components
          };
        }
      }

      cb.call(context, results);
    });
  }
}

/**
 * [Class factory method](https://leafletjs.com/reference.html#class-class-factories) for {@link Google}
 * @param options the options
 */
export function google(options?: Partial<GoogleOptions>) {
  return new Google(options);
}
